import { render, staticRenderFns } from "./failing.vue?vue&type=template&id=45223090&scoped=true&"
import script from "./failing.vue?vue&type=script&lang=js&"
export * from "./failing.vue?vue&type=script&lang=js&"
import style0 from "./failing.vue?vue&type=style&index=0&id=45223090&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45223090",
  null
  
)

export default component.exports